import {
  createPlugin,
  createRoutableExtension,
} from "@backstage/core-plugin-api";

import { rootRouteRef } from "./routes";

export const crmonPlugin = createPlugin({
  id: "crmon",
  routes: {
    root: rootRouteRef,
  },
});

export const CrmlyPage = crmonPlugin.provide(
  createRoutableExtension({
    name: "CrmlyPage",
    component: () => import("./router").then((m) => m.Router),
    mountPoint: rootRouteRef,
  })
);
